import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KVOrientationVector } from 'types'

import { KVMessageDef } from './index'

export type OrientationForwardVectorResultJSON = {
  forwardVector: KVOrientationVector
}

export function getOrientationForwardVectorResultMessage() {
  return {
    type: 'orientationForwardVectorResult',
    requiredData: ['forwardVector'],

    callback: (
      json: OrientationForwardVectorResultJSON,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const forwardVector = json.forwardVector

      // Call the callback to notify the UI that we received the forward vector
      if (kv.onOrientationForwardVectorResult) {
        kv.onOrientationForwardVectorResult(forwardVector)
      }
    },
  } as KVMessageDef
}
